import { useContext, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { APIContext } from '../../Contexts/APIContext';
import AnalysisFilterViewModel from '../ViewModels/AnalysisFilterViewModel';
import LandUseViewModel from '../../Site/ViewModels/LandUseViewModel';
import Paper from '@mui/material/Paper';

interface IProps {
    state: AnalysisFilterViewModel;
    updateState: (properties: Partial<AnalysisFilterViewModel>, callback?: (newState?: AnalysisFilterViewModel) => void) => Promise<void>;
}

export default function LanduseSelection({ state, updateState }: IProps) {
    const { get, loading } = useContext(APIContext);
    const [landUseDropDown, setLandUseDropDown] = useState<LandUseViewModel[]>([]);

    useEffect(() => {
        get("SiteList", `GetLandUseDropDown`, setLandUseDropDown);
    }, [])

    useEffect(() => {
        updateState({
            landUseMainName: landUseDropDown.find(x => x.mainLandUseCode == state.landUseMain)?.mainLandUse ?? "",
            landUseSubName: landUseDropDown.find(x => x.mainLandUseCode == state.landUseMain && x.subLandUseCode == state.landUseSub)?.subLandUse ?? "",
        })
    }, [landUseDropDown])

    const handleDropDownChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        let update: Partial<AnalysisFilterViewModel> = {};

        switch (name) {
            case "selectedMain":
                update = {
                    landUseMain: value,
                    landUseMainName: landUseDropDown.find(x => x.mainLandUseCode == value)?.mainLandUse ?? "",
                    landUseSub: "A",
                    landUseSubName: landUseDropDown.find(x => x.mainLandUseCode == value && x.subLandUseCode == "A")?.subLandUse ?? "",
                    tripRateParamHeaderIndex: 0
                }
                break;

            case "selectedSub":
                update = {
                    landUseSub: value,
                    landUseSubName: landUseDropDown.find(x => x.mainLandUseCode == state.landUseMain && x.subLandUseCode == value)?.subLandUse ?? "",
                    tripRateParamHeaderIndex: 0
                }
                break;

            default:
                console.warn(`Invalid dropdown name: ${name}`);
                return;
        }

        updateState(update)
    };

    return (
        <Grid container component={Paper} size={12} padding={2}>
            <Grid size={12}>
                <TextField
                    label="Main Land Use"
                    select
                    value={state.landUseMain}
                    name="selectedMain"
                    onChange={handleDropDownChange}
                    fullWidth
                    size='small'
                    margin="none"
                    disabled={loading}
                >
                    {Array.from(landUseDropDown
                        .filter((item) => item.archived === false)
                        .reduce((map, { mainLandUseCode, mainLandUse }) => {
                            if (!map.has(mainLandUseCode)) {
                                map.set(mainLandUseCode, mainLandUse);
                            }
                            return map;
                        }, new Map()))
                        .map(([key, value]) => (
                            <MenuItem key={key} value={key}>{`${key} - ${value}`}</MenuItem>
                        ))
                    }
                </TextField>
            </Grid>
            <Grid size={12}>
                <TextField
                    label="Sub Land Use"
                    select
                    value={state.landUseSub}
                    name="selectedSub"
                    onChange={handleDropDownChange}
                    fullWidth
                    size='small'
                    margin="none"
                    disabled={loading}
                >
                    {landUseDropDown
                        .filter((item) => item.archived === false && item.mainLandUseCode === state.landUseMain)
                        .map((item) => (
                            <MenuItem key={item.subLandUseCode} value={item.subLandUseCode}>{`${item.subLandUseCode} - ${item.subLandUse}`}</MenuItem>
                        ))
                    }
                </TextField>
            </Grid>
        </Grid>

    );
}
